import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  CContainer,
  CRow,
  CCol,
  CNav,
  CNavItem,
  CNavLink,
  CCardHeader
} from '@coreui/react';

import Summary from './summary';
import QuestionSummaries from './qsummary';

const cleanProjectId = (id) => {
  if (id == null || id === '') return '';
  const str = String(id);
  if (!str.includes('&')) return str;
  return str.split('&')[0];
};

const Dashboard = () => {
  const { projectId, projectName } = useParams();
  const [activeTab, setActiveTab] = useState('summary');

  const resolvedProjectId = cleanProjectId(projectId);
  let displayName = cleanProjectId(projectName);
  try {
    displayName = displayName ? decodeURIComponent(displayName) : displayName;
  } catch {
    // invalid encoding — use raw segment
  }

  const renderContent = () => {
    if (!resolvedProjectId) return null;
    switch (activeTab) {
      case 'summary':
        return <Summary projectId={resolvedProjectId} />;
      case 'questionSummaries':
        return <QuestionSummaries projectId={resolvedProjectId} />;
      default:
        return null;
    }
  };

  if (!resolvedProjectId || !displayName) {
    return null;
  }

  return (
    <CContainer>
      <div className="container">
        <CCardHeader>
          <div className='h2 question-summary-header'>{displayName}</div>
        </CCardHeader>
        <CNav variant="tabs" className="sub-tabs">
          <CNavItem>
            <CNavLink
              active={activeTab === 'summary'}
              onClick={() => setActiveTab('summary')}
              className={`pointer ${activeTab === 'summary' ? 'active-tab' : ''}`}
            >
              Summary
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink
              active={activeTab === 'questionSummaries'}
              onClick={() => setActiveTab('questionSummaries')}
              className={`pointer ${activeTab === 'questionSummaries' ? 'active-tab' : ''}`}
            >
              Question Summaries
            </CNavLink>
          </CNavItem>
        </CNav>
        <CRow className="mt-4">
          {activeTab ? (
            <CCol>
              {renderContent()}
            </CCol>
          ) : null}
        </CRow>
      </div>
    </CContainer>
  );
};

export default Dashboard;
